import type { FunctionComponent } from 'react';
import type { BuildCardProps } from './types';
import AutomatedBuildCard from './AutomatedBuildCard';
import CLIBuildCard from './CLIBuildCard';

/**
 * BuildCard is used as a header block in the project summary page. Depending on if the build is coming from
 * the CLI, or is an automated build, it renders two UI's
 */
const BuildCard: FunctionComponent<BuildCardProps> = ({
  status,
  reference,
  revisionId,
  isCLIBuild,
  defaultBranch,
  revisionLocator,
  revisionMessage,
  isSubmittingBuild,
  userCanEditProject,
}) => {
  if (isCLIBuild) {
    return <CLIBuildCard message={revisionMessage} revisionId={revisionId} />;
  }

  return (
    <AutomatedBuildCard
      status={status}
      reference={reference}
      defaultBranch={defaultBranch}
      revisionId={revisionId}
      revisionMessage={revisionMessage}
      isSubmittingBuild={isSubmittingBuild}
      userCanEditProject={userCanEditProject}
      revisionLocator={revisionLocator}
    />
  );
};

export default BuildCard;
